export const formatBytes = (bytes: number) => {
  const KB = 1024;
  const MB = 1024 * KB;

  // Check if the number should be represented in MB
  if (bytes >= MB) {
    return (bytes / MB).toFixed(1) + ' MB';
  }
  // Otherwise, represent it in KB
  else {
    return (bytes / KB).toFixed(1) + ' KB';
  }
};
